export default {
      id: "ic_facebook-usage",
      viewBox: "0 0 45 45",
      url: "../dist/images/" + "sprite.svg#ic_facebook-usage",
      toString: function () {
        return this.url;
      }
    }